import "./BookAppointment.module.css";
import Header from "@/reusable_sections/Header";
import DemanderUnEstime from "./sections/DemanderUnEstime";
import GrabADrink from "./sections/GrabADrink";
import Footer from "@/reusable_sections/Footer";
export default function BookAppointmentPage() {
  return <div>
      <Header />
      <DemanderUnEstime />
      <GrabADrink />
      <Footer />
    </div>;
}